package team.platforma.aicombo.activity.main.component.main.fragment

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.arrow_rigt
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.isShiftPressed
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.annotation.KoinExperimentalAPI
import team.platforma.aicombo.activity.chat.ChatActivity
import team.platforma.aicombo.args.Arg
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.dictionary_presentation.DictionaryViewModel
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.extra_nav.component.fragment_component.FragmentBox
import team.platforma.extra_nav.navigator.activity.findNavHost
import team.platforma.extra_nav.utils.Type
import team.platforma.extra_nav.utils.UI
import team.platforma.extra_nav.utils.rememberDeviceType
import team.platforma.extra_nav.utils.rememberUiOrientation
import team.platforma.multiplatform_material_extension.tab_row.AdaptiveTabRow
import team.platforma.multiplatform_material_extension.text_input.TextInput
import team.platforma.multiplatform_material_extension.text_input.style.TextInput

@OptIn(KoinExperimentalAPI::class)
object MainFragment : Fragment(
    route = "main_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->

        val dictionaryViewModel = koinViewModel<DictionaryViewModel>()
        val aiChapterList by dictionaryViewModel.aiChapterList.collectAsState()
        val aiChapterState = rememberPagerState(pageCount = { aiChapterList.size })

        val scope = rememberCoroutineScope()

        val device by rememberDeviceType()
        val orientation by rememberUiOrientation()

        var textPromptValue by remember { mutableStateOf(TextFieldValue("")) }

        FragmentBox(
            modifier = Modifier.fillMaxSize(),
            paddingValues = paddingValues
        ) {

            if (aiChapterList.isNotEmpty()) {
                Column(
                    modifier = Modifier.fillMaxSize()
                ) {
                    Spacer(
                        modifier = Modifier.height(
                            when (device) {
                                Type.MOBILE -> 8.dp
                                Type.TABLET -> 16.dp
                                Type.DESKTOP -> 16.dp
                            }
                        )
                    )
                    AdaptiveTabRow(
                        pagerState = aiChapterState,
                        tabList = aiChapterList,
                        onTabClick = { index ->
                            scope.launch {
                                aiChapterState.animateScrollToPage(index)
                            }
                        }
                    ) { tab ->
                        Text(text = tab.name)
                    }


                    HorizontalPager(
                        state = aiChapterState,
                        modifier = Modifier.fillMaxSize()
                    ) { page ->

                        val list by if (page == 0) {
                            dictionaryViewModel.observeAllAiModels()
                                .collectAsState(initial = emptyList())
                        } else {

                            dictionaryViewModel.observeAiModelsByChapter(aiChapterList[page].id)
                                .collectAsState(initial = emptyList())
                        }

                        LazyVerticalGrid(
                            columns = GridCells.Fixed(
                                when (device) {
                                    Type.MOBILE -> {
                                        when (orientation) {
                                            UI.PORTRAIT -> 1
                                            UI.LANDSCAPE -> 2
                                        }
                                    }

                                    Type.TABLET -> 2
                                    Type.DESKTOP -> 3
                                }


                            ),
                            modifier = Modifier.fillMaxSize(),
                            contentPadding = PaddingValues(
                                horizontal = when (device) {
                                    Type.MOBILE -> 16.dp
                                    Type.TABLET -> 48.dp
                                    Type.DESKTOP -> 48.dp
                                },
                                vertical = when (device) {
                                    Type.MOBILE -> 8.dp
                                    Type.TABLET -> 16.dp
                                    Type.DESKTOP -> 16.dp
                                }
                            ),
                            verticalArrangement = Arrangement.spacedBy(
                                when (device) {
                                    Type.MOBILE -> 8.dp
                                    Type.TABLET -> 16.dp
                                    Type.DESKTOP -> 16.dp
                                }
                            ),
                            horizontalArrangement = Arrangement.spacedBy(
                                when (device) {
                                    Type.MOBILE -> 8.dp
                                    Type.TABLET -> 16.dp
                                    Type.DESKTOP -> 16.dp
                                }
                            )
                        ) {

                            items(list) { item ->
                                Box(
                                    modifier = Modifier.fillMaxWidth()
                                        .shadow(4.dp, RoundedCornerShape(6.dp))
                                        .clip(
                                            RoundedCornerShape(6.dp)
                                        ).background(AppColors.bg.base().default).clickable(
                                            enabled = true
                                        ) {
                                            findNavHost().navigateToActivity(
                                                activity = ChatActivity,
                                                args = item.id
                                            )
                                        }
                                ) {
                                    Row(
                                        modifier = Modifier.fillMaxSize().padding(16.dp),
                                        verticalAlignment = when (device) {
                                            Type.MOBILE -> when (orientation) {
                                                UI.PORTRAIT -> Alignment.CenterVertically
                                                UI.LANDSCAPE -> Alignment.Top
                                            }

                                            Type.TABLET -> Alignment.Top
                                            Type.DESKTOP -> Alignment.Top
                                        }

                                    ) {

                                        Box(
                                            modifier = Modifier.size(46.dp)
                                                .clip(RoundedCornerShape(100))
                                                .background(Color.LightGray)
                                        )
                                        Column(
                                            modifier = Modifier.padding(start = 8.dp, end = 48.dp)
                                        ) {
                                            Text(
                                                text = item.name,
                                                color = AppColors.text().default,
                                                style = Typography.text2xl(FontWeights.Medium),
                                                maxLines = 1,
                                                overflow = TextOverflow.Ellipsis
                                            )
                                            Spacer(
                                                modifier = Modifier.height(2.dp)
                                            )
                                            Text(
                                                text = item.description,
                                                color = AppColors.text().default,
                                                style = Typography.textSm(FontWeights.Regular),
                                                minLines = when (device) {
                                                    Type.MOBILE -> when (orientation) {
                                                        UI.PORTRAIT -> 1
                                                        UI.LANDSCAPE -> 3
                                                    }

                                                    Type.TABLET -> 3
                                                    Type.DESKTOP -> 4
                                                },
                                                maxLines = when (device) {
                                                    Type.MOBILE -> when (orientation) {
                                                        UI.PORTRAIT -> Int.MAX_VALUE
                                                        UI.LANDSCAPE -> 3
                                                    }

                                                    Type.TABLET -> 3
                                                    Type.DESKTOP -> 4
                                                },
                                                overflow = TextOverflow.Ellipsis,

                                                )
                                        }


                                    }

                                    Box(
                                        modifier = Modifier.padding(end = 8.dp).size(40.dp)
                                            .align(Alignment.CenterEnd),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Icon(
                                            painter = painterResource(Res.drawable.arrow_rigt),
                                            contentDescription = null,
                                            tint = AppColors.text().default,
                                            modifier = Modifier.size(24.dp)
                                        )
                                    }
                                }


                            }
                        }
                    }
                }


            } else {
                CircularProgressIndicator(modifier = Modifier.align(Alignment.Center))
            }
        }
    }
)